module.exports = __webpack_public_path__ + "img/14.ed4e1e93.jpg";